import React from "react";

import RightIcon from "@mui/icons-material/ChevronRight";
import { Button, Typography } from "@mui/material";

import { User } from "@app/common/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Avatar from "@rui/Avatar";
import Stack, { Row } from "@rui/Stack";

import UserNavMenu from "../UserNavMenu";

interface SideNavFooterProps {
  user: User | null;
  showAvatar: boolean;
  onClose: () => void;
}

const SideNavFooter = ({ user, showAvatar, onClose }: SideNavFooterProps) => {
  const {
    anchorElement,
    open,
    onClick,
    onClose: onCloseMenu,
  } = useAnchorElement();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!open) {
      onClick(event);
    }
  };

  const handleClose = () => {
    onCloseMenu();
    onClose();
  };

  if (!user) {
    return <></>;
  }

  return (
    <>
      <Stack
        variant="center"
        sx={{
          minHeight: "52px",
          minWidth: showAvatar ? "0px" : "200px",
          paddingBottom: 1,
        }}
      >
        {showAvatar ? (
          <Avatar name={user.fullName} sx={{ mt: "4px" }}>
            {user.initials}
          </Avatar>
        ) : (
          <Button
            data-test-id="side-nav-footer-menu"
            onClick={handleClick}
            disableRipple
            sx={{
              padding: "8px",
              width: "100%",
              textAlign: "left",
              backgroundColor: open ? "overlay.primary.28" : undefined,
              "&:hover": {
                backgroundColor: "overlay.primary.28",
              },
            }}
          >
            <Row
              justifyContent="space-between"
              alignItems="flex-start"
              sx={{ width: "100%" }}
            >
              <Stack justifyContent="space-between">
                <Typography
                  variant="bodySecondaryMed"
                  color="#FFF"
                  sx={{ overflowWrap: "anywhere" }}
                >
                  {user.fullName}
                </Typography>
                <Typography
                  sx={{
                    overflowWrap: "anywhere",
                    fontSize: "0.75rem",
                    color: "#fff",
                    fontWeight: 400,
                  }}
                >
                  {user.email}
                </Typography>
              </Stack>
              <RightIcon sx={{ width: "16px", color: "#fff" }} />
            </Row>
          </Button>
        )}
      </Stack>

      <UserNavMenu
        open={open}
        anchorEl={anchorElement}
        handleClose={handleClose}
      />
    </>
  );
};

export default SideNavFooter;
